// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3zrRT","modalFooterButton":"ModalNotes_modalFooterButton__3qhHX"};